import api from "utils/api";
import dayjs from "dayjs";
import { PREMIUM_FIXED_PRICE } from "constants/lessonRequest";

// API 경로 상수 정의
const LESSONS_API_PATH = "/buccl_lessons/api/v1";
const USER_API_BASE_PATH = process.env.REACT_APP_USER_API_BASE_PATH;

//개설된 강습 정보
export const getOpenClassInfo = async () => {
    try {
        const res = await api.get(`${LESSONS_API_PATH}/lesson-products/`);
        return res.data;
    } catch (error) {}
};

//강사 스케쥴 등록
export const createClass = async (params) => {
    try {
        // date(단일, 하위호환) / dates(복수, 일괄 개설) 분리
        const { date, dates, ...rest } = params;
        const parsedParams = {
            ...rest,
            start_time: dayjs(params.start_time).format("HH:mm"),
            end_time: dayjs(params.end_time).format("HH:mm"),
            allowed_ticket_types:
                params.allowed_ticket_types === "NONE" ||
                params.allowed_ticket_types === "REGULAR"
                    ? "NONE"
                    : params.allowed_ticket_types,
        };

        // 다중 날짜가 있으면 dates 배열로, 없으면 기존 단일 date로 전송
        if (Array.isArray(dates) && dates.length > 0) {
            parsedParams.dates = dates.map((d) =>
                dayjs(d).format("YYYY-MM-DD")
            );
        } else {
            parsedParams.date = dayjs(date).format("YYYY-MM-DD");
        }

        const res = await api.post(
            `${LESSONS_API_PATH}/instructor-schedules/`,
            parsedParams
        );
        return res;
    } catch (error) {
        return error.response;
    }
};

// 연습 스케쥴 등록
export const createPracticeClass = async (params) => {
    try {
        const parsedParams = {
            ...params,
            start_time: dayjs(params.start_time).format("HH:mm"),
            end_time: dayjs(params.end_time).format("HH:mm"),
            date: dayjs(params.date).format("YYYY-MM-DD"),
        };
        const res = await api.post(
            `${LESSONS_API_PATH}/practice-schedules/`,
            parsedParams
        );
        return res;
    } catch (error) {
        return error.response;
    }
};

// 강사 수강생 출석관리 조회
export const getAttendanceList = async (id) => {
    try {
        const res = await api.get(
            `buccl_lessons/api/v1/instructor-schedules/${id}/reservations/`
        );
        return res.data;
    } catch (error) {
        return error.response;
    }
};
// 강사 수업 출석 체크
/*{ "attendance": [ {"reservation_id": 1, "status": "ATTENDED"}, {"reservation_id": 2, "status": "ABSENT"}, {"reservation_id": 3, "status": "NEEDS_RETAKE"} ] } */
export const attendanceComplete = async (id, target) => {
    try {
        if (target) {
            const params = {
                attendance: [
                    {
                        reservation_id: target.id,
                        status: target.status.toUpperCase(),
                    },
                ],
            };
            const res = await api.post(
                `/buccl_lessons/api/v1/instructor-schedules/${id}/complete/`,
                params
            );
            return res.data;
        } else {
            const res = await api.post(
                `/buccl_lessons/api/v1/instructor-schedules/${id}/complete/`
            );
            return res.data;
        }
    } catch (error) {
        throw error.response;
    }
};

// 연습반은 출석체크 불필요 - 함수 제거
// export const practiceAttendanceComplete = async (id, attendanceData) => {
//     try {
//         const params = {
//             attendance: attendanceData.map((item) => ({
//                 reservation_id: item.reservation_id,
//                 status: item.status.toUpperCase(),
//             })),
//         };
//         const res = await api.post(
//             `/buccl_lessons/api/v1/practice-schedules/${id}/complete/`,
//             params
//         );
//         return res.data;
//     } catch (error) {
//         throw error.response;
//     }
// };

//개설된 스케쥴 승인
export const approveCourse = async (id) => {
    try {
        const res = await api.post(
            `${LESSONS_API_PATH}/instructor-schedules/${id}/approve/`
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

//개설된 스케쥴 거절
export const rejectCourse = async (id, reason) => {
    try {
        const res = await api.post(
            `${LESSONS_API_PATH}/instructor-schedules/${id}/reject/`,
            {
                rejection_reason: reason,
            }
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

//개설된 스케쥴 수정
export const editCourse = async (id, params) => {
    try {
        const res = await api.patch(
            `${LESSONS_API_PATH}/instructor-schedules/${id}/`,
            params
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

// 자격증 승인, 거부
export const getCertificate = async () => {
    try {
        const res = await api.get(`${USER_API_BASE_PATH}/certificates/`);
        return res.data;
    } catch (error) {
        return null;
    }
};

// 자격증 승인, 거부
export const approveCertificate = async (id, action, rejection_reason = "") => {
    try {
        const res = await api.post(
            `${USER_API_BASE_PATH}/certificates/${id}/approve/`,
            {
                action: action,
                rejection_reason: rejection_reason,
            }
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

// 유저 정보 조회
export const getUserByUserId = async (userId) => {
    try {
        const res = await api.get(`${USER_API_BASE_PATH}/user-info/${userId}/`);
        return res.data;
    } catch (error) {
        return null;
    }
};

//******************** 제품/투어/클래스 등록 ************************* */

// 스포츠 상품 등록
export const createSportsProduct = async (params, thumbnails) => {
    try {
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
            if (key !== "images") {
                formData.append(key, params[key]);
            }
        });
        thumbnails.forEach((thumbnail, index) => {
            formData.append("images", thumbnail);
            formData.append("image_thumbnails", index === 0 ? true : false);
        });
        const res = await api.post(
            `/buccl_lessons/api/v1/lesson-products/`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("상품 등록 실패:", error);
        throw error.response.data;
    }
};

// 이미지 업로드
export const uploadImage = async (formData) => {
    try {
        const res = await api.post(
            `${LESSONS_API_PATH}/upload-image/`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("이미지 업로드 실패:", error);
        throw error;
    }
};

export const createTourProduct = async (params, thumbnails) => {
    try {
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
            if (key !== "images") {
                formData.append(key, params[key]);
            }
        });
        thumbnails.forEach((thumbnail, index) => {
            formData.append("images", thumbnail);
            formData.append("image_thumbnails", index === 0 ? true : false);
        });
        const res = await api.post(
            `/buccl_main/api/v1/travel-products/create/`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res.data;
    } catch (error) {
        return null;
    }
};

export const createGoodsProduct = async (params, thumbnails) => {
    try {
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
            if (key !== "images") {
                formData.append(key, params[key]);
            }
        });
        thumbnails.forEach((thumbnail, index) => {
            formData.append("images", thumbnail);
            formData.append("image_thumbnails", index === 0 ? true : false);
        });
        const res = await api.post(
            `/buccl_main/api/v1/products/create/`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res.data;
    } catch (error) {
        return null;
    }
};

// 투어 승인 대기 목록 조회
export const getTourPendingList = async () => {
    try {
        const res = await api.get(
            `/buccl_main/api/v1/travel-products-approvals/`
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

// 투어 승인/거절 요청
export const postTourAction = async (id, reject_reason) => {
    try {
        const params = {
            action: reject_reason ? "reject" : "approve",
            ...(reject_reason && { reject_reason }),
        };
        const res = await api.post(
            `buccl_main/api/v1/travel-products-approvals/${id}/action/`,
            params
        );
        return res.data;
    } catch (error) {
        return null;
    }
};

//******************** 제품 등록 관련 API ************************* */

// 정책 목록 조회
export const getPolicyOptions = async () => {
    try {
        const res = await api.get(`/buccl_main/api/v1/admin/policies/options/`);
        return res.data;
    } catch (error) {
        console.error("정책 목록 조회 실패:", error);
        throw error;
    }
};

// 카테고리 목록 조회
export const getCategories = async () => {
    try {
        const res = await api.get(`/buccl_main/api/v1/categories/`);
        return res.data;
    } catch (error) {
        console.error("카테고리 목록 조회 실패:", error);
        throw error;
    }
};

// 무료 연습반 → 유료 전환
export const convertPracticeToPaid = async (scheduleId, price) => {
    try {
        const res = await api.post(
            `${LESSONS_API_PATH}/practice-schedules/${scheduleId}/convert-to-paid/`,
            { price }
        );
        return res.data;
    } catch (error) {
        return { message: error.response?.data?.error || "유료 전환에 실패했습니다." };
    }
};

// 강습(SessionSchedule) → 유료 연습반(프리미엄 트레이닝) 전환
// 같은 시간대 PracticeSchedule 묶음 처리 (없으면 자동 생성)
// 가격 PREMIUM_FIXED_PRICE 고정, 무조건 현금 결제 (티켓 사용 불가)
// 제목 '프리미엄 트레이닝' 고정
export const convertSessionToPractice = async (sessionId) => {
    try {
        const res = await api.post(
            `${LESSONS_API_PATH}/sessions/${sessionId}/convert-to-practice/`,
            {price: PREMIUM_FIXED_PRICE, allow_ticket:false, title:'프리미엄 트레이닝'}
        );
        return res;
    } catch (error) {
        return error;
    }
};

// 제품 생성
export const createProduct = async (params, images) => {
    try {
        const formData = new FormData();

        // 기본 필드 추가
        Object.keys(params).forEach((key) => {
            if (key === "category_ids" || key === "tags") {
                // 배열 필드는 JSON 문자열로 변환
                formData.append(key, JSON.stringify(params[key]));
            } else if (key === "options") {
                // 옵션도 JSON 문자열로 변환
                formData.append(key, JSON.stringify(params[key]));
            } else if (
                key !== "images" &&
                params[key] !== null &&
                params[key] !== undefined
            ) {
                formData.append(key, params[key]);
            }
        });

        // 이미지 파일 추가
        if (images && images.length > 0) {
            images.forEach((image, index) => {
                formData.append("images", image);
                formData.append("image_thumbnails", index === 0 ? true : false);
            });
        }

        const res = await api.post(`/buccl_main/api/v1/products/`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return res.data;
    } catch (error) {
        console.error("제품 생성 실패:", error);
        throw error;
    }
};
